import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimal',
})
export class DecimalPipe implements PipeTransform {
    transform(value: number | null | undefined, ...args: unknown[]): string {
        if (value === null || value === undefined) return '0';
        const decimalPlaces = args?.length > 0 ? Number(args[0]) : 2;

        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
        }).format(value);
    }
}
